import type { ReactNode } from 'react';

interface PropiedadesResaltado {
    children: ReactNode;
    /**
     * Radio y relleno, escritorio → móvil, medidos en los tableros:
     * `grande`, el del héroe B2 (12/10 → 10/8);
     * `pagina`, el h1 de Pagina_Poderes_Chat (12/10 → 8/6: igual que `grande` en escritorio, más ceñido en móvil);
     * `normal`, el de los titulares de sección (10/8 → 8/6);
     * `blog`, el h1 de Blog_Portada, que el tablero móvil deja igual que el de escritorio (10/8 → 10/8).
     */
    tamano?: 'grande' | 'pagina' | 'normal' | 'blog';
}

const TAMANOS = {
    grande: 'rounded-[10px] px-ds-2 lg:rounded-ds-md lg:px-[10px]',
    pagina: 'rounded-ds-sm px-[6px] lg:rounded-ds-md lg:px-[10px]',
    normal: 'rounded-ds-sm px-[6px] lg:rounded-[10px] lg:px-ds-2',
    blog: 'rounded-[10px] px-ds-2',
} as const;

/**
 * El tramo resaltado de un titular. Los tableros lo dibujan con `box-decoration-break: slice`
 * (Blog_Portada, medido en Chromium): si el titular se parte en dos líneas, el relleno y el radio
 * quedan solo en los extremos del tramo. Con `clone`, la segunda línea ganaba 8 px de relleno a
 * la izquierda y el texto no casaba con el lienzo (UAT en Chrome, 17-22).
 */
export default function Resaltado({ children, tamano = 'normal' }: PropiedadesResaltado) {
    return (
        <span className={`bg-accent-blue text-on-accent-blue box-decoration-slice ${TAMANOS[tamano]}`}>
            {children}
        </span>
    );
}
